import { AppShell } from '../components/AppShell';

interface Video {
  title: string;
  description: string;
}

// Placeholder content — flesh out as videos are filmed.
const PLANNED: Video[] = [
  { title: 'Setting up your first site',         description: 'Two-minute walk-through of the site setup checklist.' },
  { title: 'Sign-in QR for the gate / cabin',    description: 'How to print the QR code so workers can sign themselves in.' },
  { title: 'Filling in a RAMS for your trade',   description: 'Pick a template, edit the bits that don\'t apply, save.' },
  { title: 'Daily / weekly site checks',         description: 'When to do them and what to tick.' },
  { title: 'Recording an accident or near-miss', description: 'Filling in the full report — what happened, RIDDOR check, action taken.' },
  { title: 'CPP — Construction Phase Plan',      description: 'For when you\'re running a notifiable job.' },
  { title: 'Permits to work',                    description: 'Hot works, dig, height, confined spaces.' },
  { title: 'Weekly hours / wages export',        description: 'Get the timesheet for your wages run or accountant.' },
  { title: 'Pulling everything for an HSE visit',  description: 'One-tap audit pack — all RAMS, sign-ins, accidents, permits and docs in one download.' },
];

export function HowToVideos() {
  return (
    <AppShell title="How-to videos" back="/">
      <div className="card" style={{ marginBottom: 16, background: 'var(--brand-pale)', borderColor: 'var(--brand-light)' }}>
        <p style={{ margin: 0, fontWeight: 600 }}>Coming soon</p>
        <p className="muted" style={{ margin: '6px 0 0', fontSize: 13 }}>
          Short videos showing you how to do everything in the app. Two minutes each, no jargon.
          We're filming them now — they'll appear here as they go live.
        </p>
      </div>

      <h3 className="section-title" style={{ marginTop: 0 }}>What's coming</h3>

      <ul className="howto-list">
        {PLANNED.map((v, i) => (
          <li key={i} className="howto-row">
            <div className="howto-thumb" aria-hidden="true">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="6 4 20 12 6 20 6 4" />
              </svg>
            </div>
            <div>
              <p className="howto-title">{v.title}</p>
              <p className="howto-sub">{v.description}</p>
              <p className="howto-status">Coming soon</p>
            </div>
          </li>
        ))}
      </ul>

      <p className="muted" style={{ marginTop: 16, fontSize: 12, textAlign: 'center' }}>
        Got a "how do I…?" question? Drop us a note and we'll add it to the list.
      </p>
    </AppShell>
  );
}
